<template>
  <div class="box">
    <h4>了解我们</h4>
    <!-- <div class="imgList">
      <img src="../../assets/img/about/1.png" alt />
      <img src="../../assets/img/about/2.png" alt />
      <img src="../../assets/img/about/3.png" alt />
    </div>-->
    <div class="main">
      <div class="common">
        <p class="title">公司简介/ COMPANY PROFILE</p>
        <p
          class="content"
        >浙江艺高文化创意有限公司是一家专注于传播中国及世界艺术文化的创新科技企业。致力于中华民族艺术的国际化传播。搭建一个集在线视频教育、艺术活动直播、移动视频社交的全新艺术教育生态系统的平台。提供的服务覆盖互联网线上教学：这里有线上音乐艺术名师培训、国内国际教育咨询、艺术作品交流分享以及乐器销售等；线下拥有艺术体验中心、大师班，国际艺术类留学及游学咨询；同时通过和各种渠道方的合作，输出iartschool.com优质师资，并有自己原创艺术视频内容制作与发行团队及渠道，搭建艺术平台、提升中国艺术教育水平。专业的能力，专注的态度，让全球顶尖艺术大师与我们共同合作，随时随地分享世界一流艺术教育资源。</p>
      </div>
      <div class="common">
        <p class="title">我们的优势-独家版权/ ADVANTAGE</p>
        <p
          class="content"
        >拥有数百位中国及亚洲、欧洲、北美、南美、澳洲著名艺术家的网络教学版权，借鉴学习欧美成熟的音乐教学视频商业模式。并在此基础上自主创新，使iartschool成为中国第一个音乐艺术的视频教育O2O平台。版权课程超过50000个视频，由多达一百多名艺术家和国际明星担纲指导；内容囊括吉他、电吉他、钢琴、大提琴、中提琴、小提琴、低音提琴、萨克斯、贝斯、爵士鼓、口琴、击弦、小号、尤克里里、演唱、电脑合成音乐、电子作品、长笛、单簧管、双簧管、长号、DJ、声乐、电子琴、儿童音乐、舞蹈、声音采集、古筝、二胡、竹笛、古琴、箜篌、绘画等视频教授课程。</p>
      </div>
      <div class="common">
        <p class="title">名师资源/ ADVANTAGE</p>
        <p
          class="content"
        >拥有国内众多活跃在艺术舞台上的音乐艺术家和专业教授，以及丰富的世界艺术教学资源，包括海外华人艺术家和教育家、国际艺术家和教育家、国内艺术家和教育家的资源。</p>
      </div>
      <div class="common">
        <p class="title">管理团队/ ADVANTAGE</p>
        <p
          class="content"
        >艺高创始人，蔡懿先生，二十多年资深媒体人，50多件作品获中国新闻奖、浙江新闻奖。2000年，阿里马云、网易丁磊、搜狐张朝阳第一次上浙江卫视录制20分钟《晚点名》人物专题，节目策划人、制作人。高级记者，正高职称，获得过浙江新闻最高奖飘萍奖，浙江省直单位改革先锋等荣誉。曾在浙江广电集团所属的浙江卫视、体育频道、经济频道、教育频道、钱江频道、广电新媒体、好易购等单位就职，是经济频道、教育频道、钱江频道的领导班子成员，主管宣传和经营。担任过临海市副市长，主管科技和信息产业。浙江广电新媒体的创始人、总经理，好易购董事长，具有视频平台和电子商务企业运营经验，管理员工数超1000人，两年时间将好易购从年销售8亿提升到50亿，净利润从亏损到盈利8000多万，并进入股改上市准备阶段。同时是中国格力天猫旗舰店项目代运营的总负责人。 团队由长期从事视频制作、互联网技术(欧洲imusicschool技术团队和美国声网技术支持)、媒体传播、艺术教育、市场销售人员及海外留学人员组成。肯吃苦善学习富有挑战精神。具备艺术文化、教育、媒体、金融、房产、通信、互联网等行业的跨界资源整合及运作能力。</p>
      </div>
      <div class="common">
        <p class="title">主营业务-线上项目/ THE MAIN BUSINESS</p>
        <p
          class="content"
        >创建 “在线艺术视频教学网站iartschool”，一个零距离、无边界、专业化的在线艺术教学平台：打破传统教学模式，再无师资资源、时间空间、单一选择的限制。</p>
        <div style="margin-top:30px;color:#666666;">
          <p style="font-size:14px;line-height:28px;">网站主要特点：</p>
          <p style="font-size:14px;line-height:28px;">1、引进imusic-school成熟运作数十年的西洋乐器视频教学课程</p>
          <p style="font-size:14px;line-height:28px;">2、录制国际国内著名的国乐艺术家的民族乐器视频教学内容及西洋乐器；</p>
          <p style="font-size:14px;line-height:28px;">3、同时启动对绘画、书法、雕塑、表演以及其他艺术领域的在线视频教学内容的录制上线；</p>
          <p style="font-size:14px;line-height:28px;">4、拥有艺术教育视频直播模块，进行1对1 、1对多的艺术直播。</p>
        </div>
      </div>
      <div class="common">
        <p class="title">主营业务-线下项目/ THE MAIN BUSINESS</p>
        <div class="content">
          <div style="color:#666666;font-size:14px;line-height:28px;">
            <p>1、iartschool艺术基地：</p>
            <div style="text-indent:14px;margin-bottom:30px;">
              <p
                style="margin-left:40px;text-indent:-38px;"
              >（1）目前在浙江拥有3处独立的iartschool艺术基地，用作线下大师班的教学基地及国内外名师的交流会所：杭州市西湖区转塘街道凤凰创意大厦3B号楼601~604，杭州地区在浙江音乐学院旁凤凰创业园的独栋别墅B19号（蔡志忠漫画馆B20）；</p>
              <p
                style="margin-left:40px;text-indent:-38px;"
              >（2）社区艺术体验中心：与万科教育集团合作，以社区住户为客户来源，提供成熟教学师资团队设立iartschool的社区艺术体验中心。 同类体验中心也将设立在中心商业区及shopping mall；</p>
              <p
                style="margin-left:40px;text-indent:-38px;"
              >（3）未来将在全球开展跨界合作，建立iartschool国际艺术交流中心：为艺术爱好者提供与全球艺术家进行面对面交流的机会；</p>
            </div>
          </div>
          <div style="color:#666666;font-size:14px;line-height:28px;">
            <p>2、音乐艺术大师班、考学考级培训班；</p>
          </div>
          <div style="color:#666666;font-size:14px;line-height:28px;">
            <p>3、世界顶级艺术巡演；</p>
          </div>
          <div style="color:#666666;font-size:14px;line-height:28px;">
            <p>4、中外艺术交流服务：与国际知名艺术院校达成合作，进行双方师资资源互换及交流；提供艺术类留学、游学的咨询服务。</p>
          </div>
        </div>
      </div>
      <div class="common">
        <p class="title">企业愿景/ ENTERPRISE VISION</p>
        <p class="content">专业的能力，专注的态度，让全球顶尖艺术大师与我们共同合作，随时随地分享世界一流艺术教育资源。</p>
      </div>
      <div class="videoBox">
        <div v-for="(item,index) in aboutList" :key="index" class="videoPlear">
            <video :src="item.promovideo" controls></video>
          <!-- <Videojs
            controls="true"
            :src="item.promovideo"
            :poster="item.promoimge"
            :playIndex="playVideoIndex"
            v-on:playVideoCallback="playVideoCallback"
          ></Videojs> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Videojs from "@/components/videojs";

export default {
  data() {
    return {
      aboutList: [],
      playVideoIndex: -1
    };
  },
  components: {
    Videojs
  },
  mounted() {
    this.getAbout();
  },
  methods: {
    playVideoCallback(data) {
      this.playVideoIndex = data.playIndex;
    },
    getAbout() {
      var _this = this;
      this.$post("iart-api-cmn/api/cmn/platformpromo/queryPlatformpromo").then(
        res => {
          if (res.code == 1) {
            if (Array.isArray(res.data)) {
              this.aboutList = res.data ? res.data : [];
            } else {
              this.aboutList.push(res.data);
            }
            /*     if (this.aboutList.length > 0) {
              for (let i = 0; i < this.aboutList.length; i++) {
                setTimeout(function() {
                  _this.showVideo(i);
                }, 0);
              }
            } */
          } else {
            this.util.toast({ msg: res.message });
          }
        }
      );
    }
    /* showVideo(index) {
      var _this = this;
      var videoPlear = document.querySelectorAll(".videoBox .videoPlear");
      var video0 = new QPlayer({
        url:(_this.aboutList[index].promovideo.indexOf('http')==-1? _this.$store.state.state.mp4Url:'') + _this.aboutList[index].promovideo, //播放地址
        container: videoPlear[index], //存放视频的容器
        autoplay: false,
        poster: _this.aboutList[index].promoimge, //封面图片
        defaultViewConfig: {
          showControls: true
        }
      });
      video0.on("play", function() {
        video0.config.defaultViewConfig.showControls = false;
      });
      video0.on("pause", function() {
        video0.config.defaultViewConfig.showControls = true;
      });
      video0.on("ended", function() {
        video0.config.defaultViewConfig.showControls = true;
      });
    } */
  }
};
</script>

<style lang="scss" scoped>
.box {
  background: #fff;
  border-radius: 10px;
  padding: 24px 16px 0;
  height: 100%;
  h4 {
    font-size: 24px;
    line-height: 40px;
  }
  .imgList {
    margin-top: 24px;
    overflow: hidden;
    img {
      display: inline-block;
      width: 31%;
      height: 160px;
      border-radius: 10px;
    }
    img:nth-of-type(2) {
      margin: 0 3%;
    }
  }
  .main {
    padding: 24px 0;
    .common {
      .title {
        font-size: 18px;
        line-height: 24px;
        color: #333;
      }
      .content {
        font-size: 14px;
        line-height: 28px;
        margin-top: 19px;
        color: #666;
      }
    }
    .common:not(:last-child) {
      margin-bottom: 24px;
    }
    .videoBox {
      .videoPlear {
        width: 100%;
        // height: 400px;
        border-radius: 5px;
        overflow: hidden;
        video {
          width: 100%;
          height: 100%;
        }
      }
      .videoPlear:not(:last-child) {
        margin-bottom: 24px;
      }
    }
  }
}
</style>